<template>
  <base-drawer
    :open="openDrawer"
    :close="closedDrawer"
    :title="getTitle(targetItem)"
    @onClose="onCloseDrawer()"
    :closeInFade="false"
    :goBack="currentContent === 'pre-definition'"
    :onTitleActionClick="backToManualContent"
    ref="catalogSortDrawer"
  >
    <!-- Contents -->
    <div v-if="currentContent === 'manual'">
      <base-card>
        <div class="pre-definition">
          <p @click="changeContent('pre-definition')">
            Ver ordens pré-definidas
          </p>
        </div>
      </base-card>

      <base-card>
        <base-box
          v-for="(item, index) in targetItem.items"
          :key="item.id"
          sortBox
        >
          <div class="item-container">
            <div class="d-flex">
              <p v-if="item.highlight" class="highlight">
                <i class="fas fa-star"></i>
              </p>
              <p>{{ item.name }}</p>
            </div>
            <div>
              <i
                class="fal fa-chevron-down sort-icon"
                :class="
                  index === targetItem.items.length - 1 ? 'hide-sort-icon' : ''
                "
                @click="moveItem(item, index, false)"
              ></i>
              <i
                class="fal fa-chevron-up ml_20 sort-icon"
                :class="index === 0 ? 'hide-sort-icon' : ''"
                @click="moveItem(item, index, true)"
              ></i>
            </div>
          </div>
        </base-box>
      </base-card>
    </div>

    <div v-else-if="currentContent === 'pre-definition'">
      <base-card>
        <div
          v-for="(preDefinition, index) in allPreDefinitions"
          :key="preDefinition.type"
        >
          <div
            v-if="targetItem.type === 'category' || preDefinition.type === 1"
            class="pre-definition-item"
            :class="
              index === allPreDefinitions.length - 1 ||
              targetItem.type !== 'category'
                ? 'pre-definition-item--no-border '
                : ''
            "
          >
            <p>{{ preDefinition.name }}</p>
            <span @click="applyPreDefinition(preDefinition.type)">
              Aplicar
            </span>
          </div>
        </div>
        <base-message class="gold mt_20">
          <span>
            Você pode voltar ao modo manual para realizar uma alteração.
          </span>
        </base-message>
      </base-card>
    </div>

    <div v-else class="success-content">
      <div class="success-content-message">
        <i class="far fa-check-circle"></i>
        <p>{{ preDefinitionMessage }}</p>
      </div>
      <div class="d-flex">
        <base-button
          text="Voltar para ordenação"
          class="w-100 big"
          @click.prevent="currentContent = 'manual'"
        />
      </div>
    </div>
    <!-- Actions -->
    <template v-if="currentContent === 'manual'" v-slot:footer>
      <div class="d-flex">
        <base-button text="Salvar" class="w-100 big" @click.prevent="save()" />
      </div>
    </template>
  </base-drawer>
</template>

<script>
// components
import BaseDrawer from '@/components/Drawer';
import BaseButton from '@/components/Button';
import BaseCard from '@/components/Card';
import BaseTabs from '@/components/Tabs';
import BaseBox from '@/components/Box';
import BaseMessage from '@/components/Message';
// libs
import Builder from 'easyjs/lib/Schema/Components/Builder';

export default {
  components: {
    BaseDrawer,
    BaseButton,
    BaseCard,
    BaseTabs,
    BaseBox,
    BaseMessage,
  },
  data() {
    return {
      originalItem: Builder.factory('Base'),
      targetItem: Builder.factory('Base'),
      openDrawer: false,
      closedDrawer: false,
      currentContent: 'manual',
      allPreDefinitions: [
        {
          name: 'Ordem alfabética',
          type: 1,
        },
        {
          name: 'Por maior valor',
          type: 2,
        },
        {
          name: 'Por menor valor',
          type: 3,
        },
      ],
      preDefinitionMessage: '',
    };
  },
  props: {
    saveSort: {
      type: Function,
    },
  },
  methods: {
    getTitle(targetItem) {
      let title = 'Ordenar - ';

      if (targetItem.type === 'category') {
        title += `${targetItem.name}`;
      } else {
        title += `Categorias`;
      }

      return title;
    },
    changeModel(item, fromSave = false) {
      if (!fromSave) {
        if (item) {
          this.originalItem = item;

          this.targetItem = Builder.mountSchema(
            JSON.parse(JSON.stringify(item))
          );
        }
      }
      this.openDrawer = !this.openDrawer;
    },
    changeContent(newContent) {
      this.currentContent = newContent;
    },
    backToManualContent() {
      this.preDefinitionMessage = '';
      this.currentContent = 'manual';
    },
    applyPreDefinition(definitionType) {
      switch (definitionType) {
        case 1:
          this.targetItem.items.sort(this.alphabeticCompare);
          this.targetItem.items.forEach((element, index) => {
            element.position = index;
          });

          this.preDefinitionMessage = 'Ordem alfabética aplicada com sucesso!';
          this.currentContent = 'success';
          break;
        case 2:
          if (this.targetItem.type === 'category') {
            this.targetItem.items.sort(this.priceCompare).reverse();
            this.targetItem.items.forEach((element, index) => {
              element.position = index;
            });

            this.preDefinitionMessage =
              'Ordem por maior valor aplicado com sucesso!';
            this.currentContent = 'success';
          }
          break;
        case 3:
          if (this.targetItem.type === 'category') {
            this.targetItem.items.sort(this.priceCompare);
            this.targetItem.items.forEach((element, index) => {
              element.position = index;
            });

            this.preDefinitionMessage =
              'Ordem por menor valor aplicado com sucesso!';
            this.currentContent = 'success';
          }
          break;
      }
    },
    alphabeticCompare(itemA, itemB) {
      const itemParent = itemA.parent_ref;

      if (itemA.name < itemB.name) {
        this.handleChangeItems(itemParent, itemB.position, itemA.position);
        return -1;
      }
      if (itemA.name > itemB.name) {
        this.handleChangeItems(itemParent, itemB.position, itemA.position);
        return 1;
      }
      return 0;
    },
    priceCompare(itemA, itemB) {
      const itemParent = itemA.parent_ref;

      if (itemA.getPrice() < itemB.getPrice()) {
        this.handleChangeItems(itemParent, itemB.position, itemA.position);
        return -1;
      }
      if (itemA.getPrice() > itemB.getPrice()) {
        this.handleChangeItems(itemParent, itemB.position, itemA.position);
        return 1;
      }
      return 0;
    },
    moveItem(item, currentIndex, up) {
      item.sorting = true;

      const clearSorting = () => {
        item.sorting = false;
        this.$forceUpdate();
      };

      setTimeout(() => {
        const itemParent = item.parent_ref;
        const newIndex = currentIndex + (up ? -1 : 1);
        if (newIndex < 0 || newIndex >= itemParent.length) {
          return false;
        }

        this.handleChangeItems(itemParent, currentIndex, newIndex);

        itemParent.items.forEach((element, index) => {
          element.position = index;
        });

        setTimeout(clearSorting, 200);
      }, 600);

      this.$forceUpdate();
    },
    handleChangeItems(parent, fromIndex, toIndex) {
      const oldItem = parent.items[toIndex];
      parent.items[toIndex] = parent.items[fromIndex];
      parent.items[fromIndex] = oldItem;

      parent.items[toIndex].changed = true;
      parent.items[fromIndex].changed = true;

      if (parent.type === 'category') parent.changed = true;
    },
    save() {
      Object.assign(this.originalItem, this.targetItem);
      this.$forceUpdate();

      this.closedDrawer = !this.closedDrawer;
      this.$emit('saveSort');
    },
    onCloseDrawer() {
      this.preDefinitionMessage = '';

      if (this.currentContent !== 'manual') {
        setTimeout(() => {
          this.currentContent = 'manual';
        }, 200);
      }
    },
  },
};
</script>

<style scoped>
.item-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #aaaaab;
  font-size: 1.2em;
}
.highlight {
  color: var(--default-hover);
  margin-right: 15px;
  font-size: 1em;
}
.sort-icon {
  cursor: pointer;
  transition: transform linear 0.15s;
}
.sort-icon:hover {
  transform: scale(1.2);
}
.pre-definition {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pre-definition p {
  font-size: 1.2em;
  text-transform: uppercase;
  padding: 5px 0;
  color: #aaaaab;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  transition: all linear 0.2;
}
.pre-definition p:hover {
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
}
.edit-button {
  height: 45px;
  border-color: #99999980;
}
.edit-button i {
  font-size: 12px;
}
.pre-definition-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #777777;
  font-size: 1.2em;
  color: #999999;
  padding: 10px 0;
}
.pre-definition-item--no-border {
  border-bottom: none;
}
.pre-definition-item p,
span {
  padding: 5px 0;
}
.pre-definition-item span {
  text-transform: uppercase;
  color: #aaaaab;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  transition: all linear 0.2;
}
.pre-definition-item span:hover {
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
}
.success-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.success-content div {
  width: 100%;
}
.success-content-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 35px;
}
.success-content-message i {
  font-size: 43px;
  color: #0dc59d;
  margin-bottom: 16px;
}
.success-content-message p {
  font-size: 1.4em;
  color: #aaaaab;
}
.disabled-apply {
  opacity: 0.8;
  cursor: default;
}
.hide-sort-icon {
  visibility: hidden;
  pointer-events: none;
}
</style>
